import ColorX from "IZOX/STATIC/ColorX";

/**
 * @type {{
 *  InLog: {
 *    show: Boolean,
 *    object: Boolean,
 *    color: String
 *  },
 *  OutLog: {
 *    show: Boolean,
 *    object: Boolean,
*     color: String
 *  }
 * }}
 */
export const ReqXSettings = {
  InLog: {
    show: true,
    object: true,
    color: ColorX.CSS("bgLightBlue")
  },
  OutLog: {
    show: true,
    object: true,
    color: ColorX.CSS("blue")
  }
};